import type { INotificationItem } from "./types";

export const notificationService = {
  /** Notifications the user hasn't seen yet (the header badge). */
  unreadCount(items: INotificationItem[] | undefined): number {
    return (items ?? []).filter((item) => item.new === true).length;
  },
};
